import React from 'react';
import { Cell, Pie, PieChart } from 'recharts';

import { formatNumber } from 'utils/number';
import {
  SPENT_CHART_CX,
  SPENT_CHART_CY,
  SPENT_CHART_INNER_RADIUS,
  SPENT_CHART_OUTER_RADIUS,
  SPENT_CHART_HEIGHT_PX,
  SPENT_CHART_WIDTH_PX,
} from './constants';

import * as S from './styles';

interface RemainingBudgetSpentChartProps {
  spentBudgetPercentage: number;
}

const AVAILABLE_COLOR = '#d4d5d7';
const SPENT_COLOR = '#1a72c6';

const RemainingBudgetSpentChart: React.FunctionComponent<
  RemainingBudgetSpentChartProps
> = (props) => {
  const { spentBudgetPercentage } = props;

  const pieData = React.useMemo(
    () => [
      { name: 'Spent', color: SPENT_COLOR, value: spentBudgetPercentage },
      {
        name: 'Avaialble',
        color: AVAILABLE_COLOR,
        value: 100 - spentBudgetPercentage,
      },
    ],
    [spentBudgetPercentage],
  );

  return (
    <S.SpentBudgetContainer>
      <PieChart height={SPENT_CHART_HEIGHT_PX} width={SPENT_CHART_WIDTH_PX}>
        <Pie
          data={pieData}
          dataKey="value"
          cx={SPENT_CHART_CX}
          cy={SPENT_CHART_CY}
          startAngle={180}
          endAngle={0}
          innerRadius={SPENT_CHART_INNER_RADIUS}
          outerRadius={SPENT_CHART_OUTER_RADIUS}
        >
          {pieData.map((entry) => (
            <Cell key={entry.name} fill={entry.color} />
          ))}
        </Pie>
      </PieChart>
      <S.SpentBudgetLegend>
        <S.SpentBudgetLegendValueText>
          {formatNumber(spentBudgetPercentage, 2)}%
        </S.SpentBudgetLegendValueText>
        <S.SpentBudgetLegendRefText>spent</S.SpentBudgetLegendRefText>
      </S.SpentBudgetLegend>
    </S.SpentBudgetContainer>
  );
};

export default RemainingBudgetSpentChart;
